import { Button, Modal, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import StarAnimation from "../lotties/star.json";
import { useSearchParams } from "react-router-dom";

const PurchaseConfirmationModal = () => {
    const [opened, { open, close }] = useDisclosure(true);

    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const [sessionId, setSessionId] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        // Check to see if this is a redirect back from Checkout
        const query = new URLSearchParams(window.location.search);

        if (query.get("success")) {
            setSuccess(true);
            setSessionId(query.get("session_id") as string);
        }

        if (query.get("canceled")) {
            setSuccess(false);
            setMessage("Order canceled -- continue to shop around and checkout when you're ready.");
        }
    }, [sessionId]);

    if (!success) {
        return null;
    }

    const handleOnClose = () => {
        setSearchParams();
        close();
    };

    return (
        <Modal opened={opened} onClose={handleOnClose} padding={30} zIndex={9999}>
            <Title className="text-orange-300 text-center">You are now premium!</Title>
            <div className="flex justify-center">
                <Lottie className="w-72" animationData={StarAnimation} loop={false} />
            </div>

            <div className="flex justify-center mt-8">
                <Button color="orange" onClick={handleOnClose} fullWidth>
                    Great
                </Button>
            </div>

            <div className="flex justify-center mt-8"></div>
        </Modal>
    );
};

export default PurchaseConfirmationModal;
